export default __webpack_public_path__ + "static/media/background-video.262d0d11.mp4";